import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
	basePath: import.meta.env.ZUDOKU_PUBLIC_BASE_PATH || "/",
	site: {
		title: "Scalebespoke",
		showPoweredBy: false,
		logo: {
			src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
			alt: "Scalebespoke",
			width: "225px",
			href: "/quickstart",
		},
	},
	navigation: [
		{
			type: "category",
			label: "Documentation",
			items: [
				{
					type: "category",
					label: "Getting Started",
					icon: "sparkles",
					items: [
						"/quickstart",
						{
							type: "link",
							icon: "folder-cog",
							badge: {
								label: "New",
								color: "purple",
							},
							label: "API Reference",
							to: "/api",
						},
					],
				},
			],
		},
		{
			type: "link",
			to: "/api",
			label: "API Reference",
		},
	],
	redirects: [{ from: "/", to: "/quickstart" }],
	apis: [
		{
			type: "file",
			input: "./apis/scalebespoke.yaml",
			path: "/api",
		},
	],
	metadata: {
		title: "%s - Scalebespoke",
	},
};

export default config;
